var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.714,
    height: 18.071,
    viewBox: "0 0 19.714 18.071",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar",
    transform: "translate(-0.75 -1.875)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_42",
    "data-name": "Trazado 42",
    d: "M19.478,4.175H15.864v-2.3H14.55v2.3H6.664v-2.3H5.35v2.3H1.736a.987.987,0,0,0-.986.986v13.8a.987.987,0,0,0,.986.986H19.478a.987.987,0,0,0,.986-.986V5.161A.987.987,0,0,0,19.478,4.175ZM19.15,18.632H2.064V5.489H5.35V7.132H6.664V5.489H14.55V7.132h1.314V5.489H19.15Z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_43",
    "data-name": "Trazado 43",
    d: "M5.25,10.5H6.564v1.314H5.25Z",
    transform: "translate(-0.557 -1.068)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_44",
    "data-name": "Trazado 44",
    d: "M9.375,10.5h1.314v1.314H9.375Z",
    transform: "translate(-1.068 -1.068)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_45",
    "data-name": "Trazado 45",
    d: "M13.125,10.5h1.314v1.314H13.125Z",
    transform: "translate(-1.532 -1.068)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_46",
    "data-name": "Trazado 46",
    d: "M17.25,10.5h1.314v1.314H17.25Z",
    transform: "translate(-2.043 -1.068)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_47",
    "data-name": "Trazado 47",
    d: "M5.25,13.875H6.564v1.314H5.25Z",
    transform: "translate(-0.557 -1.486)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_48",
    "data-name": "Trazado 48",
    d: "M9.375,13.875h1.314v1.314H9.375Z",
    transform: "translate(-1.068 -1.486)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_49",
    "data-name": "Trazado 49",
    d: "M13.125,13.875h1.314v1.314H13.125Z",
    transform: "translate(-1.532 -1.486)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_50",
    "data-name": "Trazado 50",
    d: "M17.25,13.875h1.314v1.314H17.25Z",
    transform: "translate(-2.043 -1.486)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_51",
    "data-name": "Trazado 51",
    d: "M5.25,17.25H6.564v1.314H5.25Z",
    transform: "translate(-0.557 -1.904)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_52",
    "data-name": "Trazado 52",
    d: "M9.375,17.25h1.314v1.314H9.375Z",
    transform: "translate(-1.068 -1.904)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_53",
    "data-name": "Trazado 53",
    d: "M13.125,17.25h1.314v1.314H13.125Z",
    transform: "translate(-1.532 -1.904)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_54",
    "data-name": "Trazado 54",
    d: "M17.25,17.25h1.314v1.314H17.25Z",
    transform: "translate(-2.043 -1.904)",
    fill: "#707070"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.de6214bb26b087214cff4a1a37571e86.svg";
export { ForwardRef as ReactComponent };